import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { loadModulesLocales } from '../modules'
import store from '@/store';


Vue.use(VueI18n);


// Load modules messages
const messages = loadModulesLocales();

// Load shared messages
const locales = require.context('../shared/i18n', true, /[A-Za-z0-9-_,\s]+\.json$/i);
locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
        const locale = matched[1];
        messages[locale].shared = locales(key);
    }
});

//FIXME loading local
var locale = store.getters['main/locale'];

console.debug("Loaded messages",locale, store, messages );

const i18n = new VueI18n({
    locale: locale || 'fr',
    fallbackLocale: locale || 'fr',
    messages: messages
});


/*
const glob = require('glob');




const i18n = new VueI18n({
        locale: store.state.locale,
        fallbackLocale: 'en-US',
        messages: {
            en: Object.assign({}, require('../lang/messages/en.json'), glob( '../modules//locales/en.json', {}, (err, files)=>{
                console.log(files)
            })),
            fr: Object.assign({}, require('../lang/messages/fr.json'), glob( '../modules//locales/fr.json', {}, (err, files)=>{
                console.log(files)
            })),
        },
        silentTranslationWarn: true,
    })
*/

// set a global reach
window.i18n = i18n;

export default i18n;
